module.exports = {
      id: "google-play-usage",
      viewBox: "0 0 180 53.33",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#google-play",
      toString: function () {
        return this.url;
      }
    }